import { render, staticRenderFns } from "./form-item-common.vue?vue&type=template&id=c444d1b6&"
import script from "./form-item-common.vue?vue&type=script&lang=js&"
export * from "./form-item-common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports